import React from 'react'
import { FormPro, Input } from '@roo/roo'
import { Button } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import PasswordInput, { getPswError } from '@/components/PasswordInput'
import { useRequest } from 'ahooks'
import { failToast, successToast } from '@/common/utils/toast'
import { useNavigate } from 'react-router'
import { onFormCheckFail } from '@/common/utils'
import PswIcon from './PswIcon'
import { resetPassword } from '../api'
import { encryptPsw } from '@/pages/login/utils'


const ResetPswForm = (props: {
  verifyInfo: {
    email: string;
    code: string;
  }
}) => {
  const { t } = useTranslation()
  const [resetForm] = FormPro.useForm()
  const navigate = useNavigate()
  const { verifyInfo } = props


  // 重置密码
  const { loading: resetLoading, run: resetPsw } = useRequest(async () => {
    const values = await resetForm.getFieldsValue()
    const submitPsw = await encryptPsw(values.newPassword?.trim())
    await resetPassword({
      userName: verifyInfo?.email?.trim(),
      verificationCode: verifyInfo?.code?.trim(),
      password: submitPsw,
    })

    successToast(t('e_pc_password_reset_success', '密码重置成功'))
    navigate('/login')
  }, {
    manual: true,
  })

  function handleSubmit () {
    const error = getPswError(newPassword)
    if (error) {
      failToast(error)
      return
    }
    resetPsw()
  }


  const newPassword = FormPro.useWatch('newPassword', resetForm)

  return (
    <FormPro
      name="resetForm"
      onFinish={handleSubmit}
      onFinishFailed={onFormCheckFail}
      labelCol={{ span: 12 }}
      wrapperCol={{ span: 12 }}
      layout="vertical"
      form={resetForm}
    >
      <FormPro.Item
        name="newPassword"
        label={t('e_pc_new_password', '新密码')}
      >
        <PasswordInput/>
      </FormPro.Item>
      <FormPro.Item
        name="confirmPsw"
        validateTrigger={['onBlur']}
        label={t('e_pc_confirm_password', '确认密码')}
        rules={[
          {
            validator: (_: any, value: string) => {
              if (!value) {
                return Promise.reject(new Error(t('e_pc_re_enter_new_password', '请再次输入新密码')))
              }
              if (value !== newPassword) {
                return Promise.reject(new Error(t('e_pc_password_not_same', '两次输入的密码不一致')))
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        <Input
          placeholder={t('e_pc_re_enter_new_password', '请再次输入新密码')}
          type="password"
          prefix={<PswIcon />}
        />
      </FormPro.Item>

      <FormPro.Item>
        <Button
          type="brand"
          htmlType="submit"
          style={{ width: '100%' }}
          loading={resetLoading}
          disabled={resetLoading}
        >
          {t('e_pc_reset_password', '重置密码')}
        </Button>
      </FormPro.Item>
    </FormPro>
  )
}

export default ResetPswForm